import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '../../utils/cn';
import { OmitStylesComponentProps } from '../../types';
import { cva, VariantProps } from 'class-variance-authority';

const separatorVariants = cva('rocco-separator', {
    variants: {
        variant: {
            default: 'shrink-0 bg-border',
            dark: 'shrink-0 bg-black',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const Separator = React.forwardRef<
    React.ElementRef<typeof SeparatorPrimitive.Root>,
    OmitStylesComponentProps<typeof SeparatorPrimitive.Root> &
        VariantProps<typeof separatorVariants>
>(
    (
        { orientation = 'horizontal', decorative = true, variant, ...props },
        ref,
    ) => (
        <SeparatorPrimitive.Root
            ref={ref}
            decorative={decorative}
            orientation={orientation}
            className={cn(
                separatorVariants({ variant }),
                orientation === 'horizontal'
                    ? 'h-[1px] w-full'
                    : 'h-full w-[1px]',
            )}
            {...props}
        />
    ),
);

Separator.displayName = SeparatorPrimitive.Root.displayName;
